import React from 'react';
import { HBox } from '../layout';
import { DefaultDateFormatter, intl } from '../../lib';
import { calculateYearsForDate } from '../../util';
import type { PatientDetailsPatientProp } from './internal';
import { getPatientDetailsUnknownString } from './internal';
import { Icon } from '../basic';

/**
 * Component for displaying patient's date of birth and either age or date of death.
 * If there is no date of birth, <Unknown> is shown.
 *
 * @param patient
 *          patient whose data are to be displayed
 * @param showLabel
 * @param showDeathInfo
 * @param props leftover {@link PatientDetailsPatientProp}
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function PatientDetailsBirthdateInfo({
  patient,
  showLabel = true,
  showDeathInfo = true,
  ...props
}: Readonly<PatientDetailsPatientProp>): React.JSX.Element {
  return (
    <HBox {...props} className="ehs-patient-details-date-of-birth-container">
      <>
        {showLabel && (
          <span className="date-of-birth-label">
            {intl('common.birthdate')}
          </span>
        )}
        {patient.birthdate ? (
          <span className="date-of-birth-value">
            <span className="date-container">
              {DefaultDateFormatter.formatDate(patient.birthdate)}
            </span>
            <span className="date-of-birth-value-inner">
              {' ('}
              {patient.dateOfDeath && showDeathInfo ? (
                <>
                  <Icon
                    iconName="cross-full"
                    aria-label={intl('view.patient.deceased')}
                    className="deceased-icon"
                  ></Icon>{' '}
                  {DefaultDateFormatter.formatDate(patient.dateOfDeath)}
                </>
              ) : (
                <>
                  {intl('view.patient.age')}:{' '}
                  {calculateYearsForDate(new Date(patient.birthdate))}
                </>
              )}
              {')'}
            </span>
          </span>
        ) : (
          <span>{getPatientDetailsUnknownString()}</span>
        )}
      </>
    </HBox>
  );
}
